import { render, staticRenderFns } from "./GameButtonColor.vue?vue&type=template&id=3e97e6c2&"
import script from "./GameButtonColor.vue?vue&type=script&lang=js&"
export * from "./GameButtonColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports